<template>
  <section class="container section pt-0">
    <ELEMENT_NAME-datatable />
  </section>
</template>

<script>
import CAPTIAL_ELEMENT_NAMEDatatable from "./ELEMENT_NAME_datatable/Index.vue";

export default {
  name: "CAPTIAL_ELEMENT_NAMEIndex",
  components: { CAPTIAL_ELEMENT_NAMEDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
